import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-789069fb")

_pushScopeId("data-v-789069fb")
const _hoisted_1 = /*#__PURE__*/_createVNode("section", {
  id: "error404",
  class: "flex flex-col items-center justify-center"
}, [
  /*#__PURE__*/_createVNode("h1", { class: "text-3xl text-primary font-bold pb-4" }, "404: Page Not Found"),
  /*#__PURE__*/_createVNode("h3", { class: "text-xl text-primary font-semibold text-center" }, " We couldn't find your page, but we can find your treatment! "),
  /*#__PURE__*/_createVNode("a", {
    href: "/",
    class: "\n        text-center\n        bg-accent\n        text-white\n        rounded-full\n        py-4\n        px-16\n        max-w-5xl\n        text-lg\n        font-bold\n        uppercase\n        mt-10"
  }, " Explore → ")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Container = _resolveComponent("Container")!

  return (_openBlock(), _createBlock(_component_Container, null, {
    default: _withId(() => [
      _hoisted_1
    ]),
    _: 1
  }))
})